
import { Part, PartFilter } from "@/data/parts";
import PartGrid from "@/components/PartGrid";
import PartTable from "@/components/PartTable";
import ConnectionErrorAlert from "@/components/ConnectionErrorAlert";

interface PartsContentProps {
  isSupabaseConnected: boolean | null;
  isLoading: boolean;
  filteredParts: Part[];
  viewMode: "grid" | "table";
  activeFilters: PartFilter[];
  sortBy: "none" | "rating-high" | "rating-low";
  setSortBy: (option: "none" | "rating-high" | "rating-low") => void;
}

const PartsContent = ({
  isSupabaseConnected,
  isLoading,
  filteredParts,
  viewMode,
  activeFilters,
  sortBy,
  setSortBy,
}: PartsContentProps) => {
  return (
    <div className="w-full">
      {isSupabaseConnected === false && <ConnectionErrorAlert />}
      
      {isLoading && (
        <div className="flex justify-center items-center py-4">
          <p>Loading parts...</p>
        </div>
      )}
      
      {!isLoading && (
        <div className="w-full">
          {viewMode === "grid" ? (
            <PartGrid parts={filteredParts} activeFilters={activeFilters} sortBy={sortBy} setSortBy={setSortBy} />
          ) : (
            <PartTable parts={filteredParts} activeFilters={activeFilters} />
          )}
        </div>
      )}
    </div>
  );
};

export default PartsContent;
